const ensureLeadingSlash = (value) => (value.startsWith('/') ? value : `/${value}`);

const tryResolveUrl = (path, base) => {
    if (!base) {
        return null;
    }

    try {
        return new URL(path, base).toString();
    } catch (error) {
        return null;
    }
};

export const resolveSupportAssetUrl = (url) => {
    if (!url) return '';
    if (/^https?:\/\//i.test(url) || url.startsWith('data:')) {
        return url;
    }

    const normalized = ensureLeadingSlash(url.trim());

    const explicitBases = [
        process.env.REACT_APP_API_BASE_URL,
        process.env.REACT_APP_BACKEND_URL,
        process.env.REACT_APP_BASE_URL,
    ].filter(Boolean);

    for (const base of explicitBases) {
        const resolved = tryResolveUrl(normalized, base);
        if (resolved) {
            return resolved;
        }
    }

    if (typeof window !== 'undefined' && window.location) {
        const { protocol, hostname, port } = window.location;

        const devApiPort = process.env.REACT_APP_DEV_API_PORT || process.env.REACT_APP_API_PORT || '5000';

        if ((hostname === 'localhost' || hostname === '127.0.0.1') && devApiPort) {
            if (!port || port !== devApiPort) {
                return `${protocol}//${hostname}:${devApiPort}${normalized}`;
            }
        }

        const resolved = tryResolveUrl(normalized, window.location.origin);
        if (resolved) {
            return resolved;
        }
    }

    return normalized;
};

